interface GameplayControlOptions {
  isGameplay: () => boolean;
  isPaused: () => boolean;
  pause: () => void;
  resume: () => void;
}

function hasModifier(event: KeyboardEvent): boolean {
  return event.ctrlKey || event.metaKey || event.altKey || event.shiftKey;
}

function isSpace(event: KeyboardEvent): boolean {
  return event.key === " " || event.code === "Space";
}

export class GameplayControlController {
  private readonly onKeyDown = (event: KeyboardEvent): void => {
    if (!this.options.isGameplay()) return;
    if (
      event.key === "Escape" &&
      !event.repeat &&
      !event.isComposing &&
      !hasModifier(event)
    ) {
      event.preventDefault();
      if (this.options.isPaused()) this.options.resume();
      else this.options.pause();
      return;
    }
    if (isSpace(event) && !this.options.isPaused()) {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  private readonly onKeyUp = (event: KeyboardEvent): void => {
    if (
      this.options.isGameplay() &&
      isSpace(event) &&
      !this.options.isPaused()
    ) {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  constructor(private readonly options: GameplayControlOptions) {
    window.addEventListener("keydown", this.onKeyDown);
    window.addEventListener("keyup", this.onKeyUp);
  }

  dispose(): void {
    window.removeEventListener("keydown", this.onKeyDown);
    window.removeEventListener("keyup", this.onKeyUp);
  }
}
